import { Component, Input, Signal, effect, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StateService } from "projects/shared-state/lib/state.service";
import { WorkflowState } from "projects/shared-state/public-api";
import { Workflow } from "projects/shared-state/lib/types/types";
import { User } from "firebase/auth";

@Component({
  selector: "postgenie-result-review",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./result-review.component.html",
  styleUrls: ["./result-review.component.scss"],
})
export class ResultReviewComponent {
  @Input() user: User;
  stateService = inject(StateService);

  stateSignal$: Signal<{
    workflow: WorkflowState;
  }> = this.stateService.getAppState();

  linkedInPost: string;

  currentDate: string;

  constructor() {
    effect(() => {
      const workflow: Workflow = this.stateSignal$().workflow.workflow;
      this.linkedInPost = workflow.promptWorkflow.aiResults?.postFinalEditing;
    });
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    this.currentDate = new Date().toLocaleDateString("en-US", options);
  }
}
